import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './ProductDropdownMenu.css';

const propTypes = {
  className: PropTypes.string,
  onHideMenu: PropTypes.func,
};

class ProductDropdownMenu extends Component {
  render() {
    return (
      <ul className={classnames('ProductDropdownMenu', this.props.className)}>
        <div className="ProductDropdownMenu-wrapper">
          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link"
              to="/baggage-protection"
              onClick={this.props.onHideMenu}
            >
              Baggage Protection
            </Link>
          </li>
          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link"
              to="/collectible-insurance"
              onClick={this.props.onHideMenu}
            >
              Collectibles Insurance
            </Link>
          </li>
          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link"
              to="/collectibles/fine-art-insurance"
              onClick={this.props.onHideMenu}
            >
              Fine Art Insurance
            </Link>
          </li>

          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link"
              to="/rental-car-insurance"
              onClick={this.props.onHideMenu}
            >
              Rental Car Insurance
            </Link>
          </li>
          <li className="ProductDropdownMenu-item">
            <a
              className="ProductDropdownMenu-item-link"
              href={`https://www.${
                process.env.REACT_APP_AMTRUST_DOMAIN
              }.com/product/amtrust/amtrust-renters-direct/get-started`}
              onClick={this.props.onHideMenu}
            >
              Renters Insurance
            </a>
          </li>
          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link ProductDropdownMenu-new-badge"
              to="/ridesafe-rideshare-insurance"
              onClick={this.props.onHideMenu}
            >
              RideSafe™ Insurance
            </Link>
          </li>
          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link"
              to="/small-business-owners-insurance"
              onClick={this.props.onHideMenu}
            >
              Small Business Insurance
            </Link>
          </li>
          <li className="ProductDropdownMenu-item">
            <Link
              className="ProductDropdownMenu-item-link"
              to="/smartphone-protection"
              onClick={this.props.onHideMenu}
            >
              Smartphone Protection
            </Link>
          </li>
        </div>
      </ul>
    );
  }
}

ProductDropdownMenu.propTypes = propTypes;

export default ProductDropdownMenu;
